import { BASE_URL } from '../../../configs'

import { saveAccountSettings } from '../actions/account'
import {
  createJsonHeaders,
  alertError,
  alertSuccess,
  logoutOnRequestOrResponseJson,
} from '../../../api'

const ERROR_MESSAGE = 'Sorry but something went wrong. Please ping support!'

export const getAccountSettings = adminId => {
  return fetch(`${BASE_URL}/admin/settings/${adminId}`, {
    method: 'GET',
    credentials: 'include',
    headers: createJsonHeaders(),
  })
    .then(response => {
      if (!response.ok) {
        alertError(ERROR_MESSAGE)
        return
      }

      return response.json()
    })
    .then(response => saveAccountSettings(response))
    .catch(function (error) {
      alertError(ERROR_MESSAGE)
    })
}

export const updateAccountSettings = (adminId, body) => {
  return fetch(`${BASE_URL}/admin/settings/${adminId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: createJsonHeaders(),
    body: JSON.stringify(body),
  })
    .then(response => {
      if (!response.ok) {
        alertError(ERROR_MESSAGE)
        return
      }
      alertSuccess("User's settings has been successfully updated.", 3000)
      return response.json()
    })
    .then(response => saveAccountSettings(response))
    .catch(function (error) {
      alertError(ERROR_MESSAGE)
    })
}

export const dropImage = files => {
  const file = new FormData()
  file.append('file', files[0])
  return fetch(BASE_URL + '/file', {
    credentials: 'include',
    method: 'POST',
    body: file,
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .catch(function(error) {
      alertError('Fail. Try it later', 10000)
    })
}
